<template>
  <div class="dh-body public-view min-vh-100 d-flex align-items-center">
    <!-- Background decorations -->
    <div class="dh-corner dh-corner-tl"></div>
    <div class="dh-corner dh-corner-br"></div>

    <div class="dh-card">
      <!-- HEADER -->
      <div class="dh-header">
        <img
          src="https://www.divisan.com.mx/assets/img/logo-divisan-honestidad.png"
          alt="Divisan"
          class="dh-logo"
        />
        <div class="dh-brand-tagline">Aretes para identificación de ganado</div>
      </div>

      <div class="dh-divider">
        <span class="dh-divider-text">Encuéntranos en</span>
      </div>

      <!-- LINKS -->
      <div class="dh-links">
        <!-- Sitio web -->
        <a
          href="https://www.divisan.com.mx"
          class="dh-link-btn dh-web"
          target="_blank"
          rel="noopener"
        >
          <div class="dh-link-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--d-brown)"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              width="42"
              height="42"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path
                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
              />
            </svg>
          </div>
          <div class="dh-link-label">
            Sitio web oficial
            <span class="dh-link-sublabel">www.divisan.com.mx</span>
          </div>
          <svg
            class="dh-link-arrow"
            viewBox="0 0 20 20"
            fill="currentColor"
            width="18"
            height="18"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            />
          </svg>
        </a>

        <!-- WhatsApp -->
        <a
          href="https://wa.me/message/Z3V5JG2UZAYAP1"
          class="dh-link-btn dh-whatsapp"
          target="_blank"
          rel="noopener"
        >
          <div class="dh-link-icon">
            <svg viewBox="0 0 24 24" fill="#25D366" width="42" height="42">
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
              />
            </svg>
          </div>
          <div class="dh-link-label">
            WhatsApp
            <span class="dh-link-sublabel">Chatea con nosotros</span>
          </div>
          <svg
            class="dh-link-arrow"
            viewBox="0 0 20 20"
            fill="currentColor"
            width="18"
            height="18"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            />
          </svg>
        </a>

        <!-- Facebook -->
        <a
          href="https://www.facebook.com/share/1B2SzW7V44/"
          class="dh-link-btn dh-facebook"
          target="_blank"
          rel="noopener"
        >
          <div class="dh-link-icon">
            <svg viewBox="0 0 24 24" fill="#1877F2" width="42" height="42">
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
              />
            </svg>
          </div>
          <div class="dh-link-label">
            Facebook
            <span class="dh-link-sublabel">@divisan</span>
          </div>
          <svg
            class="dh-link-arrow"
            viewBox="0 0 20 20"
            fill="currentColor"
            width="18"
            height="18"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            />
          </svg>
        </a>

        <!-- Instagram -->
        <a
          href="https://www.instagram.com/divisan_aretes?igsh=MTh6NHkxY3YwbmJrbQ=="
          class="dh-link-btn dh-instagram"
          target="_blank"
          rel="noopener"
        >
          <div class="dh-link-icon">
            <svg viewBox="0 0 24 24" width="42" height="42">
              <defs>
                <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
                  <stop offset="0%" stop-color="#f09433" />
                  <stop offset="25%" stop-color="#e6683c" />
                  <stop offset="50%" stop-color="#dc2743" />
                  <stop offset="75%" stop-color="#cc2366" />
                  <stop offset="100%" stop-color="#bc1888" />
                </linearGradient>
              </defs>
              <path
                fill="url(#ig-grad)"
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
              />
            </svg>
          </div>
          <div class="dh-link-label">
            Instagram
            <span class="dh-link-sublabel">@divisan_aretes</span>
          </div>
          <svg
            class="dh-link-arrow"
            viewBox="0 0 20 20"
            fill="currentColor"
            width="18"
            height="18"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            />
          </svg>
        </a>

        <!-- TikTok -->
        <a
          href="https://www.tiktok.com/@divisan_?_r=1&_t=ZS-95tVpgY5Diy"
          class="dh-link-btn dh-tiktok"
          target="_blank"
          rel="noopener"
        >
          <div class="dh-link-icon">
            <svg viewBox="0 0 24 24" width="42" height="42">
              <path
                fill="#FF004F"
                opacity="0.9"
                d="M19.79 7.09a5.13 5.13 0 01-4-4.5V2h-3.65v14.46a3.06 3.06 0 01-3.05 2.64 3.06 3.06 0 01-3.06-3.06 3.06 3.06 0 013.06-3.06c.3 0 .57.04.84.11V9.35a6.7 6.7 0 00-.84-.05A6.71 6.71 0 002.4 16a6.71 6.71 0 006.7 6.71 6.71 6.71 0 006.7-6.71V10.3a8.63 8.63 0 005.05 1.6V8.25a5.13 5.13 0 01-1.06-.34z"
                transform="translate(0.4, 0.4)"
              />
              <path
                fill="#00F2EA"
                opacity="0.9"
                d="M19.79 7.09a5.13 5.13 0 01-4-4.5V2h-3.65v14.46a3.06 3.06 0 01-3.05 2.64 3.06 3.06 0 01-3.06-3.06 3.06 3.06 0 013.06-3.06c.3 0 .57.04.84.11V9.35a6.7 6.7 0 00-.84-.05A6.71 6.71 0 002.4 16a6.71 6.71 0 006.7 6.71 6.71 6.71 0 006.7-6.71V10.3a8.63 8.63 0 005.05 1.6V8.25a5.13 5.13 0 01-1.06-.34z"
                transform="translate(-0.4, -0.4)"
              />
              <path
                fill="#010101"
                d="M19.79 7.09a5.13 5.13 0 01-4-4.5V2h-3.65v14.46a3.06 3.06 0 01-3.05 2.64 3.06 3.06 0 01-3.06-3.06 3.06 3.06 0 013.06-3.06c.3 0 .57.04.84.11V9.35a6.7 6.7 0 00-.84-.05A6.71 6.71 0 002.4 16a6.71 6.71 0 006.7 6.71 6.71 6.71 0 006.7-6.71V10.3a8.63 8.63 0 005.05 1.6V8.25a5.13 5.13 0 01-1.06-.34z"
              />
            </svg>
          </div>
          <div class="dh-link-label">
            TikTok
            <span class="dh-link-sublabel">@divisan_</span>
          </div>
          <svg
            class="dh-link-arrow"
            viewBox="0 0 20 20"
            fill="currentColor"
            width="18"
            height="18"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            />
          </svg>
        </a>
      </div>
      <!-- /dh-links -->
    </div>
    <!-- /dh-card -->
  </div>
</template>

<script setup>
// Sin props por ahora; los enlaces están hardcodeados.
</script>

<style scoped>
.public-view {
  font-family: "Inter", sans-serif;
  background: linear-gradient(rgba(20, 30, 40, 0.5), rgba(20, 30, 40, 0.4)),
    url("@/assets/img/Divisan/img_3.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* ══ VARIABLES ══ */
.dh-body {
  --cafe: var(--d-brown);
  --cafe-mid: #5c3210;
  --crema: var(--d-cream);
  --crema2: #f5f0c8;
  --verde: var(--d-green);
  --verde-osc: var(--d-green-dark);
  --muted: #8a7060;
  --border: #d8ccb0;
  --bg: var(--d-cream);

  min-height: 100vh;
  font-family: "Chivo", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px 48px;
  position: relative;
  overflow-x: hidden;
}

/* ── BACKGROUND GRADIENTS ── */
.dh-body::before {
  content: "";
  position: fixed;
  inset: 0;
  background: radial-gradient(
      ellipse 80% 60% at 20% 10%,
      rgba(96, 108, 56, 0.1) 0%,
      transparent 60%
    ),
    radial-gradient(ellipse 60% 40% at 80% 85%, rgba(64, 34, 8, 0.08) 0%, transparent 55%),
    radial-gradient(
      ellipse 50% 50% at 60% 50%,
      rgba(254, 250, 224, 0.6) 0%,
      transparent 70%
    );
  pointer-events: none;
  z-index: 0;
}

/* ── NOISE GRAIN ── */
.dh-body::after {
  content: "";
  position: fixed;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.03'/%3E%3C/svg%3E");
  pointer-events: none;
  opacity: 0.4;
  z-index: 0;
}

/* ── CORNERS ── */
.dh-corner {
  position: fixed;
  width: 120px;
  height: 120px;
  opacity: 0.06;
  pointer-events: none;
  z-index: 0;
}
.dh-corner-tl {
  top: -20px;
  left: -20px;
  background: radial-gradient(circle at 0% 0%, var(--verde) 0%, transparent 70%);
}
.dh-corner-br {
  bottom: -20px;
  right: -20px;
  background: radial-gradient(circle at 100% 100%, var(--cafe) 0%, transparent 70%);
}

/* ── CARD ── */
.dh-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  animation: dh-fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes dh-fadeUp {
  from {
    opacity: 0;
    transform: translateY(28px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── HEADER ── */
.dh-header {
  text-align: center;
  margin-bottom: 24px;
  animation: dh-fadeUp 0.6s 0.05s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.dh-logo {
  max-width: 200px;
  height: auto;
  margin-bottom: 12px;
  background-color: #ffffff;
  border-radius: 18px;
  padding: 15px;
}

.dh-brand-tagline {
  font-family: "Chivo Mono", monospace;
  font-size: 15px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--crema);
}

/* ── DIVIDER ── */
.dh-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  animation: dh-fadeUp 0.6s 0.1s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.dh-divider::before,
.dh-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--border);
}
.dh-divider-text {
  font-family: "Chivo Mono", monospace;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--crema);
  white-space: nowrap;
}

/* ── LINKS ── */
.dh-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dh-link-btn {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 20px;
  border-radius: 14px;
  text-decoration: none;
  font-weight: 700;
  font-size: 15px;
  color: var(--cafe);
  background: white;
  border: 1.5px solid var(--border);
  cursor: pointer;
  transition: transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.18s ease,
    background 0.15s ease, border-color 0.15s ease;
  position: relative;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  box-shadow: 0 2px 8px rgba(64, 34, 8, 0.06);
  animation: dh-fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.dh-link-btn::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 0%, transparent 60%);
  pointer-events: none;
}

.dh-link-btn:hover,
.dh-link-btn:focus-visible {
  transform: translateY(-2px) scale(1.01);
  box-shadow: 0 8px 24px rgba(64, 34, 8, 0.13), 0 2px 8px rgba(64, 34, 8, 0.08);
  border-color: transparent;
  outline: none;
}
.dh-link-btn:active {
  transform: translateY(0) scale(0.98);
  box-shadow: 0 2px 8px rgba(64, 34, 8, 0.08);
  transition-duration: 0.08s;
}

/* Hover: fondo con color de marca */
.dh-web:hover {
  background: var(--cafe);
  color: var(--crema);
}
.dh-whatsapp:hover {
  background: #25d366;
  color: white;
}
.dh-facebook:hover {
  background: #1877f2;
  color: white;
}
.dh-instagram:hover {
  background: linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
  color: white;
}
.dh-tiktok:hover {
  background: #010101;
  color: white;
}

/* Stagger animaciones */
.dh-link-btn:nth-child(1) {
  animation-delay: 0.12s;
}
.dh-link-btn:nth-child(2) {
  animation-delay: 0.18s;
}
.dh-link-btn:nth-child(3) {
  animation-delay: 0.24s;
}
.dh-link-btn:nth-child(4) {
  animation-delay: 0.3s;
}
.dh-link-btn:nth-child(5) {
  animation-delay: 0.36s;
}

/* ── ICON ──
   En reposo: invisible (solo espacio).
   En hover:  recuadro crema con border-radius suave.
   El overflow:hidden del botón NO afecta al icon porque
   el recuadro es más pequeño que el botón.
── */
.dh-link-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: transparent;
  transition: background 0.18s ease, box-shadow 0.18s ease;
}

.dh-link-btn:hover .dh-link-icon {
  background: rgba(254, 250, 224, 0.92); /* --crema semitransparente */
  box-shadow: 0 1px 6px rgba(64, 34, 8, 0.14);
}

/* ── LABEL ── */
.dh-link-label {
  flex: 1;
  line-height: 1.2;
}

.dh-link-sublabel {
  display: block;
  font-weight: 400;
  font-size: 11px;
  color: var(--muted);
  margin-top: 2px;
  font-family: "Chivo Mono", monospace;
  letter-spacing: 0.3px;
  transition: color 0.15s;
}
.dh-link-btn:hover .dh-link-sublabel {
  color: rgba(255, 255, 255, 0.7);
}

/* ── ARROW ── */
.dh-link-arrow {
  opacity: 0.3;
  flex-shrink: 0;
  transition: opacity 0.15s, transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.dh-link-btn:hover .dh-link-arrow {
  opacity: 0.7;
  transform: translateX(3px);
}

/* ── FOOTER ── */
.dh-footer {
  margin-top: 32px;
  text-align: center;
  font-family: "Chivo Mono", monospace;
  font-size: 10px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--muted);
  opacity: 0.6;
  animation: dh-fadeUp 0.6s 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}
</style>
